import moment from 'moment'
import { t } from '../i18n'
import { ROLES } from './constants'

export const STUDY_LIST_ITEM_PER_PAGE = 10

export const STUDY_LIST_STATUSES = [
  'Order Created',
  'Image Captured',
  'Images Uploading',
  'Study Stored',
  'Report Requested',
  'Study Assigned',
  'Report Dictated',
  'Report Transcribed',
  'Draft Report',
  'Provisional Report',
  'Preliminary Report',
  'Final Report',
  'Revised Report',
  'Ready for Transcription'
]

export const ASSIGNMENT_CASE_PREFIX = {
  INDEPENDENT_RADIOLOGIST: ROLES.INDEPENDENT_RADIOLOGIST,
  FACILITY: 'facility'
}

export const ASSIGNMENT_CASES = {
  UNASSIGNED: 'unassigned',
  ASSIGNED: 'assigned',
  ACCEPTED: 'accepted',
  REPORTED: 'reported',
  DECLINED: 'declined',
  REJECTED: 'rejected',
  MARKED_AS_REPORTED: 'marked_as_reported',
  NO_REPORT: 'no_report_required'
}

export const ASSIGNMENT_CASES_COLOR = {
  unassigned: null,
  assigned: 'green',
  accepted: 'green',
  reported: 'green',
  declined: 'red',
  rejected: 'red'
}

export const ASSIGNMENT_DISPLAY_TEXT = {
  unassigned: 'Not Assigned',
  assigned: 'Assigned',
  accepted: 'Accepted',
  reported: 'Reported',
  declined: 'Declined',
  rejected: 'Rejected',
  "reported (m)": 'Reported (M)',
  "marked_as_reported": 'Reported (M)',
  "no_report_required": 'No Report Required'
}

const A_GENERAL_ASSIGN = 'a_general_assign'
const B_SELF_ASSIGN = 'b_self_assign'
const C_ACCEPT = 'c_accept'
const D_DECLINE = 'd_decline'
const E_REJECT = 'e_reject'
const F_FLAG = 'f_flag'
const G_DELETE = 'g_delete'
const H_MARKED_AS_REPORTED = 'h_marked_as_reported'
const I_NO_REPORT_REQUIRED = 'i_no_report_required'

export const studyAssignmentEligibleActionKeys = {
  A_GENERAL_ASSIGN,
  B_SELF_ASSIGN,
  C_ACCEPT,
  D_DECLINE,
  E_REJECT,
  F_FLAG,
  G_DELETE,
  H_MARKED_AS_REPORTED,
  I_NO_REPORT_REQUIRED
}

export const studyAssignmentEligibleActions = {
  'a_general_assign': { displayLabel: 'study_assignment_action.assign', actionKey: 'general-assign', actionMethod: 'handleGeneralAssign' },
  'b_self_assign': { displayLabel: 'study_assignment_action.assign_study_to_me', actionKey: 'self-assign', actionMethod: 'handleAssignToSelf' },
  'c_accept': { displayLabel: 'study_assignment_action.accept_study', actionKey: 'accept', actionMethod: 'handleAcceptAssignment' },
  'd_decline': { displayLabel: 'study_assignment_action.decline_study', actionKey: 'decline', actionMethod: 'showRejectionModal' },
  'e_reject': { displayLabel: 'study_assignment_action.reject_study', actionKey: 'reject', actionMethod: 'showRejectionModal' },
  'f_flag': { displayLabel: 'study_assignment_action.flag_study', actionKey: 'direct-reject', actionMethod: 'handleDirectReject' },
  'g_delete': { displayLabel: 'study_assignment_action.delete_study', actionKey: 'delete', actionMethod: 'handleDelete' },
  'h_marked_as_reported': { displayLabel: 'study_assignment_action.report_manually', actionKey: 'marked_as_reported', actionMethod: 'handleReportManually' },
  'j_no_report_required': { displayLabel: 'study_assignment_action.no_report_required', actionKey: 'no_report_required', actionMethod: 'handleNoReportRequired' }
}

export const eligibleAssignmentActions = {
  noAssignment: [A_GENERAL_ASSIGN, B_SELF_ASSIGN, E_REJECT, G_DELETE, H_MARKED_AS_REPORTED, I_NO_REPORT_REQUIRED],
  changeAssignment: [A_GENERAL_ASSIGN, E_REJECT, G_DELETE, H_MARKED_AS_REPORTED, I_NO_REPORT_REQUIRED],
  changeAssignmentManuallyReported: [A_GENERAL_ASSIGN, E_REJECT, G_DELETE, I_NO_REPORT_REQUIRED],
  organization: {
    unassigned: [A_GENERAL_ASSIGN, B_SELF_ASSIGN, G_DELETE, H_MARKED_AS_REPORTED, I_NO_REPORT_REQUIRED]
  },
  facility: {
    unassigned: [],
    assigned: [A_GENERAL_ASSIGN, C_ACCEPT],
    accepted: [],
    reported: [],
    declined: [],
    rejected: []
  },
  radiologistSelf: {
    unassigned: [],
    assigned: [C_ACCEPT, D_DECLINE], // [C_ACCEPT, D_DECLINE, F_FLAG],
    accepted: [], // [D_DECLINE, F_FLAG],
    reported: [],
    declined: [C_ACCEPT, D_DECLINE],
    rejected: [C_ACCEPT]
  },
  radiologistColleague: {
    unassigned: [],
    assigned: [B_SELF_ASSIGN],
    accepted: [],
    reported: [],
    declined: [B_SELF_ASSIGN],
    rejected: [B_SELF_ASSIGN]
  },
  independentRadiologist: {
    unassigned: [],
    assigned: [C_ACCEPT], // [C_ACCEPT, D_DECLINE, F_FLAG],
    accepted: [], // [D_DECLINE, F_FLAG],
    reported: [],
    declined: [],
    rejected: []
  }
}
export const ASSIGNMENT_CASCADE_KEYS = {
  MYSELF: 'self_radiologist_guid',
  FACILITY: 'facility_guid',
  INTERNAL_RADIOLOGIST: 'internal_radiologist_guid',
  EXTERNAL_RADIOLOGIST: 'external_radiologist_guid',
  ORGANIZATION: 'organization_guid'
}
export const ASSIGNMENT_CASCADE_OPTIONS = {
  self_radiologist_guid: { label: t('assignment_cascade_option.myself'), reference: 'radiologist_id' },
  facility_guid: { label: t('assignment_cascade_option.my_facilities'), reference: 'facility_guid' },
  internal_radiologist_guid: { label: t('assignment_cascade_option.staff_radiologists'), reference: 'radiologist_id' },
  external_radiologist_guid: { label: t('assignment_cascade_option.independent_radiologists'), reference: 'radiologist_id' },
  organization_guid: { label: t('assignment_cascade_option.radiology_providers'), reference: 'organization_guid' }
}


export const studyListParameterSchema = {
  accessionNumber: '',
  bodyPart: '',
  createdAt: 'descend',
  modality: '',
  offset: 0,
  patientId: '',
  patientName: '',
  limit: STUDY_LIST_ITEM_PER_PAGE,
  priority: '',
  radiology: '',
  searchText: '',
  facilityName: '',
  status: ''
}

export const workListParameterSchema = {
  accessionNumber: '',
  bodyPart: '',
  createdAt: 'descend',
  modality: '',
  offset: 0,
  patientId: '',
  patientName: '',
  priority: '',
  radiology: '',
  searchText: '',
  facilityName: '',
  status: 'assigned,accepted'
  // fromDate: moment().subtract(2, 'days').format('YYYY-MM-DDTHH:mm:ss[Z]'),
}